// styles
import styled, { css } from 'styled-components';
import { gridSizes, media } from 'utils/style';

/* TD
    -> magic numbers
*/
const regularCSS = css`
  grid-column-start: 3;
  grid-column-end: 11;
  -ms-grid-column: 3;
  -ms-grid-column-span: 10;
  padding: ${gridSizes('S')} 0;
`;

const mobileCSS = `
    grid-column-start: 1;
    grid-column-end: 7;
    padding: 0 ${gridSizes('M')};
`;

const GridRow = styled.div`
  ${regularCSS}
  ${media.lessThan('extraSmall')`${mobileCSS}`}
`;

export default GridRow;
